import React from 'react';
import Route from './Route';

export default function PrivateRoute(props) {
  return (
    <Route
      authenticated={true}
      redirectPath="/login"
      {...props}
    />
  );
}
